import { Button, Typography } from '@mui/material'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import Modal from '../modal/Modal'
import messages from './ConfirmAcceptDeclinedProduct.messages'

export interface IOwnProps {
}
export interface IStateProps {
  product?: OrderProduct
  shouldShowConfirmDialog: boolean
}
export interface IDispatchProps {
  closeConfirmDialog: () => void
  confirmAcceptDeclinedProduct: (product: OrderProduct) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const ConfirmAcceptDeclinedProduct: React.FC<IProps> = (props) => {
  const {
    product,
    shouldShowConfirmDialog,
    closeConfirmDialog,
    confirmAcceptDeclinedProduct,
  } = props

  const handleConfirm = () => {
    if (product) {
      confirmAcceptDeclinedProduct(product)
    }
  }

  return (
    <Modal
      modalName='confirm-accept-declined-product'
      open={shouldShowConfirmDialog}
      onClose={closeConfirmDialog}
      header={() => (
        <>
          <Typography gutterBottom>
            <FormattedMessage {...messages.header} />
          </Typography>

          <Typography>
            <FormattedMessage {...messages.subheader} />
          </Typography>
        </>
      )}
    >
      <Button color='primary' variant='contained' onClick={handleConfirm} fullWidth>
        <FormattedMessage {...messages.confirm} />
      </Button>
    </Modal>
  )
}

export default ConfirmAcceptDeclinedProduct
